export default {
  newWindow: 'Se abre en una ventana nueva',
}
